// extracted by mini-css-extract-plugin
export default {"searchContainer":"Search_searchContainer__jLZ2V","input":"Search_input__U18Wd"};